module.exports = __webpack_public_path__ + "static/media/home-background.3b3f925c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/themes/assets/tepual/home/home-background.jpg
// module id = 1673
// module chunks = 0